import { useCallback } from 'react';
import { useQAPairConversationKnowledgeQuery } from './useQAPair';
import { isIdEqual } from 'utils/is';

interface Result {
  source: SupplementKnowledge.Source;
  knowledgeQuery: Conversation.KnowledgeQueryMessage;
}

/**
 * 判断消息是属于哪个source
 */
export const useGetMessageQAPairSource = () => {
  const conversationKnowledgeQuery = useQAPairConversationKnowledgeQuery();

  const getType = useCallback(
    (queryMsgId: string): Result | undefined => {
      if (!conversationKnowledgeQuery) {
        return;
      }

      const { knowledgeQuery, knowledgeReply, knowledgeQueries, knowledgeReplies } =
        conversationKnowledgeQuery;

      if (knowledgeReply && isIdEqual(knowledgeReply.msgId, queryMsgId)) {
        return {
          source: 'AI_ERROR_REPLY',
          knowledgeQuery: knowledgeReply,
        };
      }
      const matchedKnowledgeReply = knowledgeReplies?.[queryMsgId];
      if (matchedKnowledgeReply) {
        return {
          source: 'AI_ERROR_REPLY',
          knowledgeQuery: matchedKnowledgeReply.query,
        };
      }
      if (knowledgeQuery && isIdEqual(knowledgeQuery.msgId, queryMsgId)) {
        return {
          source: 'CUSTOMER',
          knowledgeQuery,
        };
      }
      const matchedKnowledgeQuery = knowledgeQueries?.find((item) =>
        isIdEqual(item.msgId, queryMsgId),
      );
      if (matchedKnowledgeQuery) {
        return {
          source: 'CUSTOMER',
          knowledgeQuery: matchedKnowledgeQuery,
        };
      }
      return;
    },
    [conversationKnowledgeQuery],
  );

  return useCallback(
    (msg: Conversation.Message): Result | undefined => {
      if (!conversationKnowledgeQuery) {
        return;
      }

      const { extraInfo } = msg;

      return extraInfo?.popupFor ? getType(extraInfo?.popupFor) : undefined;
    },
    [conversationKnowledgeQuery, getType],
  );
};
